var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGrayRanks(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 25,
    viewBox: "0 0 18 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7876 0H2.21244C1.01607 0 0 1.00379 0 2.30161V23.1837C0.00352052 24.831 1.93755 25.6039 3.03708 24.4476L8.21154 19.0661C8.62621 18.6161 9.37379 18.6161 9.78846 19.0661L14.9629 24.4476C16.0629 25.6043 17.9967 24.8302 18 23.1837V2.30161C18 1.00379 16.9839 0 15.7876 0Z",
    fill: "#CDDBDB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrayRanks);
export default __webpack_public_path__ + "static/media/grayRanks.a859d36a5107d838b8e4d665092322d6.svg";
export { ForwardRef as ReactComponent };